"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var InfoIFill = function InfoIFill(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    viewBox: "0 0 24 24",
    height: "20px",
    width: "20px"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm0 19a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112 19zm1.6-6.08a1 1 0 00-.6.917 1 1 0 01-2 0 3 3 0 011.8-2.75A2 2 0 1010 9.255a1 1 0 01-2 0 4 4 0 115.6 3.665z"
  }));
};
InfoIFill.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
InfoIFill.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = InfoIFill;